import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import {
  EsIcon,
  FarmsIcon,
  IconDocs,
  IconEn,
  IconVi,
  IconZh,
  KoIcon,
  LimitOrderIcon,
  PoolsIcon,
  SwapIcon,
  YourliquidityIcon,
} from 'src/components/icon/Nav';

import { SWAP_TYPE_KEY } from '../pages/SwapPage';
// import { XrefIcon } from 'src/components/icon/Xref';
import { APP_META, FEATURES } from '../services/config';

export const useLanguageItems = () => {
  const lan = [
    {
      label: 'English',
      language: 'en',
      logo: <IconEn />,
    },
    {
      label: '中文',
      language: 'zh-CN',
      logo: <IconZh />,
    },
    {
      label: 'Việt',
      language: 'vi',
      logo: <IconVi />,
    },

    {
      label: '한국어',
      language: 'ko',
      logo: <KoIcon />,
    },
    {
      label: 'Español',
      language: 'es',
      logo: <EsIcon />,
    },
  ];
  return lan;
};

// Menu shared by the desktop and mobile navigation. Entries for optional
// features only appear when their contracts are configured (FEATURES).
const buildMenuData = (history: any, onNavigate?: () => void) => {
  const navigateTo = (path: string) => {
    onNavigate && onNavigate();
    history.push(path);
  };
  const tradeChildren = [
    {
      id: '1-1',
      label: <>Swap</>,
      logo: <SwapIcon />,
      url: '/',
      isExternal: false,
      swap_mode: 'normal',
      clickEvent: () => {
        sessionStorage.setItem(SWAP_TYPE_KEY, 'Lite');
        localStorage.setItem('SWAP_MODE_VALUE', 'normal');
        navigateTo('/');
      },
      links: ['/', '/swap'],
    },
  ];
  // Limit orders are placed on the DCL contract.
  if (FEATURES.dcl) {
    tradeChildren.push({
      id: '1-2',
      label: (
        <>
          <FormattedMessage id="limit_order" />
        </>
      ),
      logo: <LimitOrderIcon />,
      url: '/',
      isExternal: false,
      swap_mode: 'limit',
      clickEvent: () => {
        sessionStorage.setItem(SWAP_TYPE_KEY, 'Pro');
        localStorage.setItem('SWAP_MODE_VALUE', 'limit');
        navigateTo('/');
      },
      links: ['/', '/myOrder', '/swap'],
    });
  }

  const earnChildren: any[] = [
    {
      id: '2-1',
      label: (
        <>
          <FormattedMessage id="liquidity_pools_2" />
        </>
      ),
      logo: <PoolsIcon />,
      url: '/pools',
      isExternal: false,
      links: ['/pools', '/pool', '/poolV2', '/more_pools'],
    },
    {
      id: '2-2',
      label: (
        <>
          <FormattedMessage id="your_liquidity" />
        </>
      ),
      logo: <YourliquidityIcon />,
      url: '/yourliquidity',
      isExternal: false,
      links: ['/yourliquidity', '/yoursLiquidityDetailV2'],
    },
  ];
  if (FEATURES.boostFarms) {
    earnChildren.push({
      id: '2-3',
      label: (
        <>
          <FormattedMessage id="farms" />
        </>
      ),
      logo: <FarmsIcon />,
      url: '/v2farms',
      isExternal: false,
      links: ['/v2farms', '/farms'],
    });
  }

  const menuData: any[] = [
    {
      id: '1',
      label: (
        <>
          <FormattedMessage id="trade" />
        </>
      ),
      links: ['/', '/myOrder', '/swap'],
      children: tradeChildren,
    },
    {
      id: '2',
      label: (
        <>
          <FormattedMessage id="earn_2" />
        </>
      ),
      links: [
        '/pools',
        '/pool',
        '/poolV2',
        '/more_pools',
        '/yourliquidity',
        '/yoursLiquidityDetailV2',
        '/farms',
        '/v2farms',
      ],
      children: earnChildren,
    },
  ];

  if (APP_META.docsUrl) {
    menuData.push({
      id: '5',
      label: (
        <>
          <FormattedMessage id="more_2" />
        </>
      ),
      links: [],
      children: [
        {
          id: '5-2',
          label: <FormattedMessage id="docs" />,
          url: APP_META.docsUrl,
          isExternal: true,
          logo: <IconDocs />,
        },
      ],
    });
  }
  return menuData;
};

export const useMenus = (onNavigate?: () => void) => {
  const history = useHistory();

  return buildMenuData(history);
};
export const useMenusMobile = (
  setShow: (show: boolean) => void
): menuItemType[] => {
  const history = useHistory();
  const navigateTo = (path: string) => {
    setShow(false);
    history.push(path);
  };
  return [
    {
      id: 'swap',
      label: <>Swap</>,
      links: ['/', '/swap'],
      clickEvent: () => {
        sessionStorage.setItem(SWAP_TYPE_KEY, 'Lite');
        localStorage.setItem('SWAP_MODE_VALUE', 'normal');
        navigateTo('/');
      },
    },
    {
      id: 'liquidity',
      label: <>Liquidity</>,
      links: [
        '/pools',
        '/pool',
        '/poolV2',
        '/more_pools',
        '/yourliquidity',
        '/yoursLiquidityDetailV2',
      ],
      clickEvent: () => navigateTo('/pools'),
    },
  ];
};

export interface menuItemType {
  id?: string;
  label: JSX.Element;
  logo?: JSX.Element;
  renderLogo?: (prop: any) => JSX.Element;
  url?: string;
  isExternal?: boolean;
  children?: menuItemType[];
  clickEvent?: () => void;
  links?: string[];
  swap_mode?: string;
  icon?: JSX.Element;
  hidden?: boolean;
  hoverLabel?: JSX.Element;
}
